import axios from "axios";
import { base_route } from "../../backend";
axios.defaults.baseURL = base_route;
// makes an API request to verify OTP
export const verifyOTP = function (email, otp, token, personID) {
  let payload = { email, otp, token, personID };
  return new Promise((resolve, reject) => {
    axios
      .post("/adminauth/verify", payload)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const loginWithOTP = (email) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/adminauth/send`, { email })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => reject(err));
  });
};

export const loginWithPassword = (email, password) => {
  return fetch(`${base_route}/adminauth/signin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  })
    .then((resp) => {
      return resp.json();
    })
    .catch((err) => console.log(err));
};

export const getProfile = (token) => {
  return (
    fetch(`${base_route}/adminauth/getProfile`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "bearer-token": `${token}`,
      },
    })
      .then((resp) => {
        return resp.json();
      })
      // .then((data) => console.log(data))
      .catch((err) => console.log(err))
  );
};
export const resetPassword = (newPassword, token, otp) => {
  console.log(newPassword, token);
  return fetch(`${base_route}/adminauth/resetpassword/verify`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token, newPassword, otp }),
  })
    .then((resp) => {
      return resp.json();
    })
    .catch((err) => console.log(err));
};

export const authenticate = (data, next) => {
  if (typeof window != "undefined") {
    sessionStorage.setItem("tk_jwt", JSON.stringify(data));
    next();
  }
};
export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  if (sessionStorage.getItem("tk_jwt")) {
    return JSON.parse(sessionStorage.getItem("tk_jwt"));
  } else {
    return false;
  }
};
export const logout = (next) => {
  if (typeof window != "undefined") {
    sessionStorage.removeItem("tk_jwt");
    // sessionStorage.removeItem("profile-url");
    next();
  }
};
